module.exports = __webpack_public_path__ + "static/media/Illus-DietaryRestrictions.8f3ce61e.png";